export default "/images/vendor/flag-icon-css/flags/4x3/cd.svg?4b82821f4a615f2d8c262772a7bdd1aa";